// src/components/CustomModal.jsx
import React, { useRef, useEffect } from "react";
import "./index.css";

const CustomModal = ({ show, onClose, title, children }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal" ref={modalRef}>
        <div className="custom-modal-header">
          <h3 className="custom-modal-title">{title}</h3>
          <button className="custom-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="custom-modal-body d-flex">{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;
